import { Modal } from 'antd'
import React, { useState } from 'react'
import { BANNER_DUCK } from '../../core/actions'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import Button from '../button'
import Input from '../input'
import TermsAndConditions from '../termsAndConditions'
import Text from '../text'
import { useResendMigrationOTP, useSendMigrationOTP, useVerifyMigrationOTP } from './hook'

export const UnDismissableBanner = () => {
  const {
    financierState: { financier },
    bannerState: { openBannerKeys },
  } = useGlobal()
  const { bannerDispatch } = useGlobalDispatch()
  const { data: sendOTPData, mutate: sendMutate } = useSendMigrationOTP({ id: financier?.financierId })
  const { mutate: resendMutate } = useResendMigrationOTP({
    id: financier?.financierId,
    otp_verification_id: sendOTPData?.otp_verification_id,
  })
  const { mutate: verifyMutate, isPending: isVerifyPending } = useVerifyMigrationOTP({
    id: financier?.financierId,
    otp_verification_id: sendOTPData?.otp_verification_id,
  })
  const [acceptedNotedChanges, setAcceptedNotedChanges] = useState(false)
  const [showTNC, setShowTNC] = useState(false)
  const [acceptedTerms, setAcceptedTerms] = useState(false)
  const [otp, setOTP] = useState('')
  const [showOTPInput, setShowOTPInput] = useState(false)

  const handleOkClick = () => {
    verifyMutate({ otp_to_be_verified: otp })
  }

  const handleSendOTP = () => {
    setShowOTPInput(true)
    sendMutate()
  }

  const handleCancelClick = () => {
    bannerDispatch({ type: BANNER_DUCK.HIDE_BANNER, payload: 'blockInteraction' })
  }

  const handleNoteChange = e => {
    if (e.target.checked) {
      setAcceptedNotedChanges(true)
    } else {
      setAcceptedNotedChanges(false)
    }
  }

  const handleTermsChange = e => {
    if (e.target.checked) {
      setAcceptedTerms(true)
    } else {
      setAcceptedTerms(false)
    }
  }

  return (
    <Modal
      title={'Important Notice'}
      open={openBannerKeys.includes('blockInteraction')}
      onOk={handleOkClick}
      onCancel={handleCancelClick}
      footer={null}
      width={800}
      // closeIcon={<AiFillCloseCircle size='var(--modal-close-icon-size)' />}
      bodyStyle={{ maxHeight: '80vh', overflowY: 'scroll', padding: '1rem 1.5rem' }}>
      {/* <img width={250} height={250} src={promotionIcon} alt={'Promotion Banner Icon'}></img> */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
        <Text>
          Hello <Text bold>{financier?.financierName},</Text>
        </Text>
        <Text>
          This is to inform you that your Virtual Escrow Number has been changed. Details of the New Virtual Escrow
          Number are as below:
        </Text>
        <ul style={{ marginTop: '0.2rem', marginBottom: '0.2rem' }}>
          <li style={{ marginTop: '0.2rem' }}>
            <Text>Account Number:</Text> <Text bold>{financier?.escrow?.accountNumber}</Text>
          </li>
          <li style={{ marginTop: '0.2rem' }}>
            <Text>IFSC Code:</Text> <Text bold>{financier?.escrow?.IFSC}</Text>
          </li>
          <li style={{ marginTop: '0.2rem' }}>
            <Text>Branch:</Text> <Text bold>{financier?.escrow?.bankName}</Text>
          </li>
        </ul>
        <Text>You may also see the changes in Profile -&gt; Escrow Account</Text>
        <div>
          <input type='checkbox' checked={acceptedNotedChanges} onChange={handleNoteChange} name='notedChanges' />
          <Text>I have noted the changes to my Virtual Account and accept the same</Text>
        </div>
        <div>
          <input type='checkbox' checked={acceptedTerms} onChange={handleTermsChange} name='termsAndConditions' />
          <Text>I hereby agree to these</Text>
          <Button type='text' handleClick={() => setShowTNC(true)}>
            <Text color='#1a73e8'>Terms & Conditions </Text>
          </Button>
        </div>
        {showOTPInput && (
          <>
            <Text>Enter OTP sent to your registered mobile number</Text>
            <div style={{ maxWidth: '40%', marginBottom: '1rem' }}>
              <Input onChange={val => setOTP(val)} value={otp} placeholder='Enter OTP' />
              <Button type='text' onClick={() => resendMutate()}>
                Resend OTP
              </Button>
            </div>
          </>
        )}

        <TermsAndConditions showTNC={showTNC} setShowTNC={setShowTNC} />
        <div style={{ gap: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
          {showOTPInput ? (
            <Button
              type='primary'
              disabled={isVerifyPending || !(acceptedNotedChanges && acceptedTerms && otp)}
              onClick={handleOkClick}>
              Submit OTP
            </Button>
          ) : (
            <Button type='primary' disabled={!(acceptedNotedChanges && acceptedTerms)} onClick={handleSendOTP}>
              Accept
            </Button>
          )}

          <Button type='danger' onClick={handleCancelClick}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  )
}
